import { Layers } from 'lucide-react';

/** Split display strings like "Cardiology · Nephrology · Endocrinology" into branch labels. */
export function splitLensGroupBranches(label: string): string[] {
  const normalized = label.replace(/\s+/g, ' ').trim();
  if (!normalized) return [];
  const parts = normalized.split(/\s*·\s*/).map((s) => s.trim()).filter(Boolean);
  return parts.length ? parts : [normalized];
}

export function ClinicalLensGroupCards({ labels }: { labels: string[] }) {
  if (!labels.length) return null;
  const multi = labels.length > 1;

  return (
    <div className="space-y-2.5">
      <p className="text-[11px] font-medium uppercase tracking-[0.14em] text-text-tertiary">
        Clinical lenses
      </p>
      <div
        className={
          multi
            ? 'grid grid-cols-1 gap-3 sm:grid-cols-2'
            : 'grid grid-cols-1 gap-3 max-w-2xl'
        }
      >
        {labels.map((label, i) => {
          const branches = splitLensGroupBranches(label);
          return (
            <article
              key={`${label}-${i}`}
              className="group relative overflow-hidden rounded border border-border/90 border-l-[3px] border-l-border bg-linear-to-br from-surface-raised to-surface-sunken/20 shadow-sm ring-1 ring-border/35"
            >
              <div className="flex gap-3 px-3 py-3.5 sm:px-3.5">
                <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-border/60 bg-surface-sunken/35 text-text-tertiary">
                  <Layers className="h-4 w-4" strokeWidth={2} aria-hidden />
                </div>
                <div className="min-w-0 flex-1 space-y-2">
                  <div className="flex flex-wrap items-baseline gap-x-2 gap-y-0.5">
                    <h4 className="text-[11px] font-medium uppercase tracking-wide text-text-tertiary">
                      {multi ? `Specialty group ${i + 1}` : 'Specialty group'}
                    </h4>
                  </div>
                  <div className="flex flex-wrap gap-1.5">
                    {branches.map((branch) => (
                      <span
                        key={branch}
                        className="inline-flex max-w-full items-center rounded-lg border border-border/70 bg-background/90 px-2.5 py-1 text-left text-[13px] font-medium leading-snug text-foreground shadow-sm"
                      >
                        {branch}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </article>
          );
        })}
      </div>
    </div>
  );
}
